<template>
  <b-field v-bind="$attrs">
    <template #label>
      {{ label }}<InfoHint v-if="hintKey" :messageKey="hintKey" class="ml-1" />
    </template>
    <slot />
  </b-field>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InfoHint from './InfoHint.vue'

export default defineComponent({
  name: 'BFieldHint',
  components: { InfoHint },
  inheritAttrs: true,
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    hintKey: {
      type: String,
      required: false,
      default: ''
    }
  }
})
</script>

